import {skipToken} from '@reduxjs/toolkit/query';

import {isNotNil} from 'ramda-adjunct';

import {MyWebResponseBody, useGetMyWebPlatformQuery} from '@dms/api/sales';
import {useBranchId} from '@dms/settings/shared';

type ResolvedParams = {branchId?: string} | undefined;

type UseMyWebPlatformResolvedResult = {
  activeData: MyWebResponseBody | undefined;
  resolvedParams: ResolvedParams;
  isFetching: boolean;
  isError: boolean;
  isPublishingOnTenant: boolean;
};

export function useMyWebPlatformResolved(): UseMyWebPlatformResolvedResult {
  const branchId = useBranchId();
  const params = {branchId};

  const {
    data: dataGeneral,
    isFetching: isFetchingGeneral,
    isError: isErrorGeneral,
  } = useGetMyWebPlatformQuery({params});

  const isPublishingOnTenant = isNotNil(branchId) && !!dataGeneral?.publishOnTenant;

  const {
    data: dataTenant,
    isFetching: isFetchingTenant,
    isError: isErrorTenant,
  } = useGetMyWebPlatformQuery(isNotNil(branchId) ? undefined : skipToken);

  return {
    activeData: isPublishingOnTenant ? dataTenant : dataGeneral,
    resolvedParams: isPublishingOnTenant ? undefined : params,
    isFetching: isFetchingGeneral || isFetchingTenant,
    isError: isErrorGeneral || isErrorTenant,
    isPublishingOnTenant,
  };
}
